"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExternalStatus = void 0;
var constants_1 = require("../constants");
var InternalToExternalMapper = new Map([
    [constants_1.InternalClaimStatus.Cancelled, constants_1.ExternalClaimStatus.Cancelled],
    [constants_1.InternalClaimStatus.New, constants_1.ExternalClaimStatus.New],
    [constants_1.InternalClaimStatus.ReviewRequired, constants_1.ExternalClaimStatus.InProgress],
    [constants_1.InternalClaimStatus.InProgress, constants_1.ExternalClaimStatus.InProgress],
    [constants_1.InternalClaimStatus.Pending, constants_1.ExternalClaimStatus.InProgress],
    [constants_1.InternalClaimStatus.Declined, constants_1.ExternalClaimStatus.Declined],
    [constants_1.InternalClaimStatus.ApprovedAuto, constants_1.ExternalClaimStatus.Paid],
    [constants_1.InternalClaimStatus.ApprovedManual, constants_1.ExternalClaimStatus.Paid],
    [constants_1.InternalClaimStatus.NoClaimPayable, constants_1.ExternalClaimStatus.NoClaimPayable],
    [constants_1.InternalClaimStatus.ClaimPaymentInProgress, constants_1.ExternalClaimStatus.Paid],
    [constants_1.InternalClaimStatus.Paid, constants_1.ExternalClaimStatus.Paid],
    [constants_1.InternalClaimStatus.PaymentFailed, constants_1.ExternalClaimStatus.Paid],
    [constants_1.InternalClaimStatus.RefundRequested, constants_1.ExternalClaimStatus.RefundRequested],
    [constants_1.InternalClaimStatus.CmhcReimbursed, constants_1.ExternalClaimStatus.CmhcReimbursed],
    [constants_1.InternalClaimStatus.ApprovalRequired, constants_1.ExternalClaimStatus.InProgress],
]);
exports.getExternalStatus = function (internalStatus) {
    var InternalToExternalMapping = InternalToExternalMapper.get(internalStatus);
    return InternalToExternalMapping;
};
